/**
 * Operator Cross-Client Campaigns — KB's view.
 * Create campaigns across multiple clients' agents.
 */

import { useState, useEffect } from "react";
import { getClients } from "../lib/api-clients";

export function OperatorCampaignsView() {
  const [campaigns, setCampaigns] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ name: "", tenant_ids: "", objective: "" });

  useEffect(() => {
    const clients = getClients();
    if (!clients) { setLoading(false); return; }
    // Fetch all campaigns across tenants
    clients.control.getFleet()
      .then((res: any) => {
        const all = (res?.tenants || []).flatMap((t: any) => (t.campaigns || []).map((c: any) => ({ ...c, tenant: t.name || t.id })));
        setCampaigns(all);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  async function create() {
    if (!form.name.trim()) return;
    const clients = getClients();
    if (!clients) return;
    try {
      const tenantIds = form.tenant_ids.split(",").map((s) => s.trim()).filter(Boolean);
      await clients.control.createOperatorCampaign({
        name: form.name,
        tenant_ids: tenantIds,
        objective: form.objective,
      });
      setForm({ name: "", tenant_ids: "", objective: "" });
      setShowCreate(false);
    } catch (err: any) { setError(err.message); }
  }

  if (loading) return <div className="loading">Loading…</div>;

  return (
    <div className="view">
      <div className="view-header">
        <span className="eyebrow">Operator</span>
        <h1>Cross-Client Campaigns</h1>
        <button className="btn-primary" onClick={() => setShowCreate(!showCreate)}>New cross-client campaign</button>
      </div>
      {error && <div className="error-state">{error}</div>}
      {showCreate && (
        <div className="card form-card">
          <div className="form-row">
            <label>Campaign name</label>
            <input className="text-input" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} />
          </div>
          <div className="form-row">
            <label>Tenant IDs (comma-separated)</label>
            <input className="text-input" value={form.tenant_ids} onChange={(e) => setForm({...form, tenant_ids: e.target.value})} placeholder="tenant-1,tenant-2" />
          </div>
          <div className="form-row">
            <label>Objective</label>
            <input className="text-input" value={form.objective} onChange={(e) => setForm({...form, objective: e.target.value})} />
          </div>
          <button className="btn-primary" onClick={create}>Create</button>
        </div>
      )}
      {campaigns.length === 0 ? (
        <div className="empty-state">No cross-client campaigns yet.</div>
      ) : (
        <table className="data-table">
          <thead><tr><th>Campaign</th><th>Tenant</th><th>Status</th><th>Leads</th><th>Replies</th></tr></thead>
          <tbody>
            {campaigns.map((c: any, i: number) => (
              <tr key={i}>
                <td>{c.name}</td>
                <td>{c.tenant}</td>
                <td><span className="badge" data-status={c.status}>{c.status || "draft"}</span></td>
                <td>{c.leads_count ?? 0}</td>
                <td>{c.replies ?? 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
